<template>
    <div class="message">
        <b-card no-body v-if="$store.state.logget" class="message-form mb-4" @click.stop="toggle($event)">
            <template v-if="delay">
                <b-skeleton type="input" width="100%"/>
            </template>
            <template v-else>
                <b-form-textarea @click.self="toggle($event)" :no-resize="form.resize" v-model="text" :style="'height:' + form.height + 'px;'" rows="2" :placeholder="$t('default.ln_3')"/>
                <div class="mt-3" v-if="form.toggle">
                    <div class="float-left">
                        <b-button @click="form.dialog = !form.dialog" variant="light"><i class="fal fa-smile-wink"/></b-button>
                        <b-button @click.prevent v-b-toggle href="#poll-collapse" class="ml-2" variant="light"><i class="fal fa-poll-h"/></b-button>
                        <!-- Modal box emoji list. -->
                        <VEmojiPicker class="ml-2" v-show="form.dialog" :labelSearch="$t('default.ln_0')" :i18n="$i18n.locale" @select="emoji"/>
                    </div>
                    <div class="float-right">
                        <b-overlay :show="form.delay" opacity="0.6" spinner-small spinner-variant="primary" class="d-inline-block">
                            <b-button @click="setMessage" :disabled="form.delay" variant="info"><i class="fal fa-location-arrow"/> {{ $t('default.ln_1') }} / {{count}}</b-button>
                        </b-overlay>
                    </div>
                    <div class="clearfix"></div>
                    <!-- Modal box poll. -->
                    <b-collapse id="poll-collapse" class="w-100">
                        <hr/>
                        <b-card>
                            <b-form-input v-model="poll.name" :placeholder="$t('default.ln_4')"/>
                            <hr/>
                            <b-input-group class="mt-2" v-for="(input,k) in poll.source" :key="k">
                                <b-form-input :placeholder="$t('default.ln_5')" v-model="input.text"/>
                                <b-input-group-append>
                                    <i style="padding: 11px 0 11px 11px;" class="fal fa-minus-circle" @click="deletePoll(k)" v-show="k || ( !k && poll.source.length > 1)"/>
                                    <i style="padding: 11px 0 11px 11px;" class="fal fa-plus-circle" @click="setPoll(k)" v-show="k === poll.source.length-1"/>
                                </b-input-group-append>
                            </b-input-group>
                        </b-card>
                    </b-collapse>
                </div>
            </template>
        </b-card>
        <span class="text-center w-100 mt-4" style="display: block" v-if="delay">
            <b-spinner label="Spinning"/>
        </span>
        <span v-else>
			<b-card class="message-item mb-4" v-for="item in items" :key="item.id" :message-id="item.id" style="box-shadow: none">
				<b-media class="overflow-hidden">
					<template v-slot:aside>
                        <b-avatar variant="default" :src="item.image" :text="item.name | namegr" size="3rem"/>
					</template>
					<h5 class="mt-0">
						<router-link :to="'/address/'+ item.from"><b>{{ item.name ? item.name : item.from.slice(0, 20) + '...' }}</b></router-link> <small class="text-muted"><i class="fal fa-clock"/> <time-ago :refresh="1" long :locale="$i18n.locale" :datetime="item.timestamp * 1000" :tooltip="true"/></small>
						<span class="float-right" v-if="item.delete" lg="1" style="padding-right: 10px">
							<b-button @click="deleteMessage(item.id, item.type)" variant="light"><i class="fal fa-trash-alt text-secondary"/></b-button>
						</span>
					</h5>
					<span class="text-wrap text-break">{{item.text }}</span>
					<poll :scope-id="Number(item.id)" scope-type="message"/>
				</b-media>
				<template v-slot:footer>
					<comment :scope-parent="Number(item.id)" :scope-master="address" scope-type="comment-message"/>
				</template>
			</b-card>
            <span v-if="items.length === 0">
				<div class="text-center my-5 py-5">
					<i class="mb-4 display-4 fal fa-id-card-alt"/>
					<h3>{{ $t('address.ln_2') }}</h3>
				</div>
            </span>
            <span v-else>
                <b-button v-if="more.show" @click="getMore" class="mb-5 w-100" variant="light">
                    <b-spinner v-if="more.loading" small/> <i v-else class="fas fa-angle-down text-info"></i>
                </b-button>
            </span>
        </span>
    </div>
</template>


<script lang="js">

    import api              from '../libs/api';
    import axios            from 'axios';
    import Comment          from '../components/Comment';
    import Poll             from '../components/Poll';
    import {VEmojiPicker}   from 'v-emoji-picker';
    import TimeAgo          from 'vue2-timeago';

    const STATUS_OK = "OK";

    export default {
        name: "message",
        components: {
            Comment,
            Poll,
            VEmojiPicker,
            TimeAgo,
        },
        props: {
            scopeType: {
                type: String
            },
            scopeParent: {
                type: Number
            },
            scopeAddress: {
                type: String
            }
        },
        data() {
            return {
                type: this.$props.scopeType,
                address: this.$props.scopeAddress,
                parent: this.$props.scopeParent,
                poll: {
                    component: false,
                    name: null,
                    source: [
                        {
                            text: null
                        }
                    ],
                },
                message: {
                    id: 0,
                    name: null,
                    from: null,
                    to: null,
                    text: null,
                    image: null,
                    delete: true,
                    timestamp: 0
                },
                form: {
                    toggle: false,
                    height: 40,
                    resize: true,
                    dialog: false,
                    delay: false
                },
                more: {
                    show: false,
                    loading: false
                },
                items: [],
                text: "",
                delay: false,
                count: 0
            }
        },
        watch: {
            $route() {
                this.$data.type = this.$props.scopeType;
                this.$data.address = this.$props.scopeAddress;

                this.getMessage(0, true)
            }
        },
        mounted() {
            this.getMessage(0, true)
        },
        methods: {
            setPoll() {
                this.$data.poll.source.push({text: null});
            },
            deletePoll(index) {
                this.$data.poll.source.splice(index, 1);
            },
            toggle(event) {
                event = event || window.event;

                this.$data.form.toggle = true;
                this.$data.form.resize = false;
                this.$data.form.height = 60;

                if (event.cancelBubble === false) {
                    event.stopPropagation();
                    document.body.addEventListener('click', () => {
                        this.$data.form.toggle = false;
                        this.$data.form.resize = true;
                        this.$data.form.height = 40;
                        this.$data.form.dialog = false;
                        event.cancelBubble = false;
                    });
                }
            },
            emoji(emoji) {
                this.$data.text += emoji.data;
            },
            getMore(clearning) {
                this.getMessage(this.$data.items[this.$data.items.length - 1].id, clearning)
            },
            getMessage(last, clearning) {

                if (last) {
                    this.$data.more.loading = true;
                } else {
                    this.$data.delay = true;
                }

                axios.post(api.message.list, {
                    from: this.$data.address,
                    parent: this.$data.parent,
                    type: this.$data.type,
                    last: last
                }).then(async (response) => {

                    await this.$store.dispatch('getLocalStorageObject', 'account').then(async (account) => {

                        if (!last) {
                            this.$data.items = [];
                        }

                        if (clearning) {
                            this.$data.count = 0;
                        }

                        if (response.data.source !== undefined) {
                            this.$data.count = response.data.count;

                            for (let i = 0; i < response.data.source.length; i++) {

                                await this.$storage("account", response.data.source[i].from, response.data.source[i].image).then((response) => {
                                    this.$data.message.image = response;
                                });

                                this.$data.message.id = response.data.source[i].id;
                                this.$data.message.name = response.data.source[i].name;
                                this.$data.message.from = response.data.source[i].from;
                                this.$data.message.to = response.data.source[i].to;
                                this.$data.message.text = response.data.source[i].text;
                                this.$data.message.type = response.data.source[i].type;
                                this.$data.message.timestamp = response.data.source[i].timestamp;
                                this.$data.message.delete = true;

                                if (account) {
                                    if (account.address === this.$data.address) {
                                        this.$data.message.delete = true;
                                    } else {
                                        this.$data.message.delete = account.address === response.data.source[i].from;
                                    }
                                } else {
                                    this.$data.message.delete = false;
                                }

                                this.$data.items.push(Object.assign({}, this.$data.message));
                            }

                            this.$data.more.show = this.$data.count > this.$data.items.length;
                        }

                        this.$store.commit('setMessageCount', {
                            count: this.$data.count
                        });

                        if (last) {
                            this.$data.more.loading = false;
                        } else {
                            this.$data.delay = false;
                        }
                    });

                }).catch((error) => {
                    this.$bvToast.toast(`${error.response.data.code}: ${error.response.data.message}`, {
                        title: this.$t('error.ln_5'),
                        autoHideDelay: 5000,
                        toaster: 'b-toaster-bottom-right',
                        variant: 'danger',
                    });
                });
            },
            setMessage() {
                if (this.$data.text) {
                    this.$data.form.delay = true;

                    // Poll validate items.
                    if (this.$data.poll.name) {
                        if (this.$data.poll.source.length > 1) {
                            this.$data.poll.component = true;
                        } else if (this.$data.poll.source.length === 1) {
                            this.$bvToast.toast(`${this.$t('error.ln_14')}`, {
                                title: this.$t('error.ln_5'),
                                autoHideDelay: 5000,
                                toaster: 'b-toaster-bottom-right',
                                variant: 'danger',
                            });

                            this._.delay(() => {
                                this.$data.form.delay = false;
                            }, 1000);
                            return false;
                        }
                    }

                    axios.post(api.message.send, {
                        to: this.$data.address,
                        parent: this.$data.parent,
                        text: this.$data.text,
                        type: this.$data.type,
                        poll: this.$data.poll
                    }).then(async (response) => {

                        await this.$storage("account", response.data.source[0].from, response.data.source[0].image).then((response) => {
                            this.$data.message.image = response;
                        });

                        this.$data.message.id = response.data.source[0].id;
                        this.$data.message.name = response.data.source[0].name;
                        this.$data.message.from = response.data.source[0].from;
                        this.$data.message.to = response.data.source[0].to;
                        this.$data.message.text = response.data.source[0].text;
                        this.$data.message.type = response.data.source[0].type;
                        this.$data.message.delete = true;
                        this.$data.message.timestamp = response.data.source[0].timestamp;

                        this.$data.items.unshift(Object.assign({}, this.$data.message));

                        this.$data.count += 1;
                        this.$data.text = "";
                        this.$data.form.dialog = false;

                        this.$store.commit('setMessageCount', {
                            count: this.$data.count
                        });

                        if (this.$data.poll.source.length > 1) {
                            this.$root.$emit('bv::toggle::collapse', 'poll-collapse');
                        }

                        // Poll done.
                        this.$data.poll.name = null;
                        this.$data.poll.source = [];
                        this.$data.poll.source.push({
                            text: null
                        });

                        this._.delay(() => {
                            this.$data.form.delay = false;
                        }, 1000);

                    }).catch((error) => {
                        this._.delay(() => {
                            this.$data.form.delay = false;
                        }, 1000);
                        this.$bvToast.toast(`${error.response.data.code}: ${error.response.data.message}`, {
                            title: this.$t('error.ln_5'),
                            autoHideDelay: 5000,
                            toaster: 'b-toaster-bottom-right',
                            variant: 'danger',
                        });
                    });
                } else {
                    this.$bvToast.toast(`${this.$t('error.ln_6')}`, {
                        title: this.$t('error.ln_5'),
                        autoHideDelay: 5000,
                        toaster: 'b-toaster-bottom-right',
                        variant: 'danger',
                    });
                }
            },
            deleteMessage(id, type) {
                axios.post(api.message.delete, {id: id, type: type}).then((response) => {
                    if (response.data.status === STATUS_OK) {
                        this.$data.items.splice(this._.findKey(this.$data.items, {id: id}), 1);
                        this.$data.count -= 1;

                        this.$store.commit('setMessageCount', {
                            count: this.$data.count
                        });

                        if (this.$data.items.length === 1) {
                            this.getMore(false);
                        }
                    }
                }).catch((error) => {
                    this.$bvToast.toast(`${error.response.data.code}: ${error.response.data.message}`, {
                        title: this.$t('error.ln_5'),
                        autoHideDelay: 5000,
                        toaster: 'b-toaster-bottom-right',
                        variant: 'danger',
                    });
                });
            }
        }
    }
</script>

<style scoped>
    .message > .message-form {
        background-color: #f0f2f7;
        border-top: 1px solid #eceaea;
        box-shadow: none;
    }

    .message .message-item .card-footer {
        border-top: 1px solid #eceaea;
        padding: 0 !important;
        margin-left: 60px;
        box-shadow: none;
    }
</style>